// import React, { useState, useEffect } from "react";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import { getRecordedSessionById, getRelatedSessions } from "../services/recordedSessionsService";

// const WatchSessionPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
  
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [sessionData, setSessionData] = useState(null);
//   const [relatedSessions, setRelatedSessions] = useState([]);
//   const [activeTab, setActiveTab] = useState("content");

//   useEffect(() => {
//     window.scrollTo(0, 0);
    
//     const fetchSessionData = async () => {
//       try {
//         setLoading(true);
        
//         // Fetch session details
//         const session = await getRecordedSessionById(id);
//         setSessionData(session);
        
//         // Fetch related sessions
//         const related = await getRelatedSessions(id);
//         setRelatedSessions(related);
        
//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching session data:", err);
//         setError("Failed to load session. Please try again later.");
//         setLoading(false);
//       }
//     };
    
//     fetchSessionData();
//   }, [id]);

//   if (loading) {
//     return (
//       <div className="pt-20 flex justify-center items-center min-h-screen">
//         <div className="text-center">
//           <div className="animate-spin h-12 w-12 text-indigo-600 mx-auto mb-4 rounded-full border-t-2 border-b-2 border-indigo-600"></div>
//           <p className="text-gray-600">Loading session...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error || !sessionData) {
//     return (
//       <div className="pt-20 flex justify-center items-center min-h-screen">
//         <div className="text-center max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
//           <svg
//             className="h-16 w-16 text-gray-400 mx-auto mb-4"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//             />
//           </svg>
//           <h1 className="text-xl font-bold text-gray-900 mb-2">
//             Session Not Found
//           </h1>
//           <p className="text-gray-600 mb-6">
//             {error || "We couldn't find the session you're looking for. It may have been moved or deleted."}
//           </p>
//           <Link
//             to="/online-classes"
//             className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-colors duration-300"
//           >
//             Return to Classes
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="pt-20">
//       {/* Video Player Header */}
//       <section className="bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="py-8">
//             <div className="flex items-center mb-3">
//               <span
//                 className={`inline-block rounded-full text-xs font-semibold px-2.5 py-0.5 mr-3 ${
//                   sessionData.type === "foundation"
//                     ? "bg-green-100 text-green-800"
//                     : sessionData.type === "prelims"
//                     ? "bg-blue-100 text-blue-800"
//                     : "bg-purple-100 text-purple-800"
//                 }`}
//               >
//                 {sessionData.type.charAt(0).toUpperCase() + sessionData.type.slice(1)}
//               </span>
//               <span className="bg-indigo-100 text-indigo-800 text-xs font-medium rounded px-2.5 py-0.5">
//                 {sessionData.subject}
//               </span>
//             </div>
//             <h1 className="text-2xl md:text-3xl font-bold mb-4">{sessionData.title}</h1>
//             <div className="flex flex-wrap items-center text-sm text-gray-300 mb-4">
//               <div className="flex items-center mr-6 mb-2">
//                 <svg
//                   className="w-4 h-4 mr-1"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                   />
//                 </svg>
//                 <span>{sessionData.instructor}</span>
//               </div>
//               <div className="flex items-center mr-6 mb-2">
//                 <svg
//                   className="w-4 h-4 mr-1"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//                 <span>{sessionData.duration}</span>
//               </div>
//               <div className="flex items-center mr-6 mb-2">
//                 <svg
//                   className="w-4 h-4 mr-1"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                   />
//                 </svg>
//                 <span>{new Date(sessionData.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
//               </div>
//               {sessionData.rating && (
//                 <div className="flex items-center mb-2">
//                   <svg
//                     className="w-4 h-4 text-yellow-400 mr-1"
//                     fill="currentColor"
//                     viewBox="0 0 20 20"
//                   >
//                     <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                   </svg>
//                   <span>
//                     {sessionData.rating} ({sessionData.ratingCount} reviews)
//                   </span>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Vimeo Video Player */}
//       <section className="bg-black">
//         <div className="max-w-5xl mx-auto">
//           <div className="relative" style={{ paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
//             <iframe 
//               src={`https://player.vimeo.com/video/${sessionData.vimeoId}?title=0&byline=0&portrait=0`} 
//               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} 
//               frameBorder="0" 
//               allow="autoplay; fullscreen; picture-in-picture" 
//               allowFullScreen
//               title={sessionData.title}
//             ></iframe>
//           </div>
//         </div>
//       </section>

//       {/* Content Tabs */}
//       <section className="py-8 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="border-b border-gray-200 mb-8">
//             <div className="flex space-x-8">
//               <button
//                 className={`pb-4 text-base font-medium ${
//                   activeTab === "content"
//                     ? "border-b-2 border-indigo-600 text-indigo-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//                 onClick={() => setActiveTab("content")}
//               >
//                 Session Content
//               </button>
//               <button
//                 className={`pb-4 text-base font-medium ${
//                   activeTab === "materials"
//                     ? "border-b-2 border-indigo-600 text-indigo-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//                 onClick={() => setActiveTab("materials")}
//               >
//                 Materials
//               </button>
//               <button
//                 className={`pb-4 text-base font-medium ${
//                   activeTab === "instructor"
//                     ? "border-b-2 border-indigo-600 text-indigo-600"
//                     : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                 }`}
//                 onClick={() => setActiveTab("instructor")}
//               >
//                 Instructor
//               </button>
//             </div>
//           </div>

//           <div className="flex flex-col lg:flex-row">
//             {/* Main Content Area */}
//             <div className="lg:w-2/3 lg:pr-12">
//               {/* Session Content Tab */}
//               {activeTab === "content" && (
//                 <div>
//                   <div className="mb-8">
//                     <h2 className="text-2xl font-bold text-gray-900 mb-4">
//                       Session Overview
//                     </h2>
//                     <p className="text-gray-600 mb-6">{sessionData.description}</p>
                    
//                     {sessionData.highlights && sessionData.highlights.length > 0 && (
//                       <>
//                         <h3 className="text-xl font-bold text-gray-900 mb-3">
//                           What You'll Learn
//                         </h3>
//                         <div className="grid md:grid-cols-2 gap-4 mb-6">
//                           {sessionData.highlights.map((highlight, index) => (
//                             <div key={index} className="flex items-start">
//                               <svg
//                                 className="h-5 w-5 text-green-500 mt-0.5"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M5 13l4 4L19 7"
//                                 />
//                               </svg>
//                               <span className="ml-2 text-gray-600">{highlight}</span>
//                             </div>
//                           ))}
//                         </div>
//                       </>
//                     )}
//                   </div>

//                   {sessionData.syllabus && sessionData.syllabus.length > 0 && (
//                     <div className="mb-8">
//                       <h2 className="text-2xl font-bold text-gray-900 mb-4">
//                         Session Syllabus
//                       </h2>
//                       <div className="border rounded-lg overflow-hidden divide-y divide-gray-200">
//                         {sessionData.syllabus.map((section, index) => (
//                           <div key={index} className="p-6 bg-white">
//                             <div className="flex justify-between items-start mb-2">
//                               <h3 className="text-lg font-medium text-gray-900">
//                                 {section.title}
//                               </h3>
//                               <span className="bg-gray-100 text-gray-700 text-sm px-2 py-1 rounded">
//                                 {section.duration}
//                               </span>
//                             </div>
//                             <ul className="pl-5 list-disc text-gray-600">
//                               {section.topics.map((topic, topicIndex) => (
//                                 <li key={topicIndex} className="mb-1">
//                                   {topic}
//                                 </li>
//                               ))}
//                             </ul>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {sessionData.prerequisites && sessionData.prerequisites.length > 0 && (
//                     <div className="mb-8">
//                       <h2 className="text-2xl font-bold text-gray-900 mb-4">
//                         Prerequisites
//                       </h2>
//                       <ul className="space-y-2">
//                         {sessionData.prerequisites.map((prerequisite, index) => (
//                           <li key={index} className="flex items-start">
//                             <svg
//                               className="h-5 w-5 text-indigo-500 mt-0.5"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                               />
//                             </svg>
//                             <span className="ml-2 text-gray-600">{prerequisite}</span>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Materials Tab */}
//               {activeTab === "materials" && (
//                 <div>
//                   <h2 className="text-2xl font-bold text-gray-900 mb-6">
//                     Study Materials
//                   </h2>
                  
//                   {(!sessionData.materials || sessionData.materials.length === 0) ? (
//                     <div className="bg-gray-50 p-6 rounded-lg text-center">
//                       <svg
//                         className="w-12 h-12 text-gray-400 mx-auto mb-4"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                         />
//                       </svg>
//                       <p className="text-gray-600">No materials are available for this session.</p>
//                     </div>
//                   ) : (
//                     <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
//                       <ul className="divide-y divide-gray-200">
//                         {sessionData.materials.map((material, index) => (
//                           <li key={index} className="p-4 hover:bg-gray-50">
//                             <div className="flex items-center">
//                               <div className="flex-shrink-0 mr-3">
//                                 <svg
//                                   className="h-6 w-6 text-indigo-500"
//                                   fill="none"
//                                   viewBox="0 0 24 24"
//                                   stroke="currentColor"
//                                 >
//                                   <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                                   />
//                                 </svg>
//                               </div>
//                               <div className="flex-1">
//                                 <h3 className="text-base font-medium text-gray-900">
//                                   {material}
//                                 </h3>
//                               </div>
//                               <div>
//                                 <button className="inline-flex items-center text-indigo-600 hover:text-indigo-800">
//                                   <span>Download</span>
//                                   <svg
//                                     className="w-4 h-4 ml-1"
//                                     fill="none"
//                                     stroke="currentColor"
//                                     viewBox="0 0 24 24"
//                                   >
//                                     <path
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       strokeWidth={2}
//                                       d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
//                                     />
//                                   </svg>
//                                 </button>
//                               </div>
//                             </div>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Instructor Tab */}
//               {activeTab === "instructor" && (
//                 <div>
//                   <h2 className="text-2xl font-bold text-gray-900 mb-6">
//                     About the Instructor
//                   </h2>
//                   <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
//                     <div className="flex items-center mb-6">
//                       <div className="mr-4 h-16 w-16 rounded-full overflow-hidden bg-gray-200">
//                         {/* Placeholder for instructor image */}
//                         <svg
//                           className="h-full w-full text-gray-400"
//                           fill="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
//                         </svg>
//                       </div>
//                       <div>
//                         <h3 className="font-bold text-lg text-gray-900">
//                           {sessionData.instructor}
//                         </h3>
//                         <p className="text-indigo-600">Expert in {sessionData.subject}</p>
//                       </div>
//                     </div>
//                     <p className="text-gray-600 mb-4">
//                       Our instructor is an experienced educator specializing in NPSC exam preparation
//                       with extensive knowledge in {sessionData.subject}.
//                     </p>
//                     <Link
//                       to={`/instructors/${sessionData.instructor.toLowerCase().replace(/\s+/g, "-")}`}
//                       className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
//                     >
//                       <span>View Full Profile</span>
//                       <svg
//                         className="w-4 h-4 ml-1"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M17 8l4 4m0 0l-4 4m4-4H3"
//                         />
//                       </svg>
//                     </Link>
//                   </div>
//                 </div>
//               )}

//               {/* Related Sessions */}
//               {relatedSessions.length > 0 && (
//                 <div className="mt-12">
//                   <h2 className="text-2xl font-bold text-gray-900 mb-6">
//                     Related Sessions You May Like
//                   </h2>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     {relatedSessions.map((relSession) => (
//                       <div
//                         key={relSession._id}
//                         className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300"
//                       >
//                         <div className="relative h-40">
//                           <img
//                             src={relSession.image}
//                             alt={relSession.title}
//                             className="w-full h-full object-cover"
//                           />
//                           <div className="absolute inset-0 flex items-center justify-center">
//                             <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center">
//                               <svg
//                                 className="w-6 h-6 text-indigo-600"
//                                 fill="currentColor"
//                                 viewBox="0 0 20 20"
//                               >
//                                 <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
//                               </svg>
//                             </div>
//                           </div>
//                           <div className="absolute top-0 right-0 m-2">
//                             <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2 py-0.5 rounded">
//                               {relSession.subject}
//                             </span>
//                           </div>
//                           <div className="absolute bottom-0 left-0 m-2">
//                             <span className="bg-black/60 text-white text-xs font-medium px-2 py-0.5 rounded">
//                               {relSession.duration}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="p-4">
//                           <h3 className="text-lg font-bold text-gray-900 mb-1 line-clamp-1">
//                             {relSession.title}
//                           </h3>
//                           <p className="text-sm text-gray-600 mb-2">
//                             {relSession.instructor}
//                           </p>
//                           <Link
//                             to={`/watch-session/${relSession._id}`}
//                             className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
//                           >
//                             Watch Now
//                           </Link>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Sidebar */}
//             <div className="lg:w-1/3 mt-8 lg:mt-0">
//               {/* Session Info Card */}
//               <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
//                 <div className="p-6">
//                   <h2 className="text-xl font-bold text-gray-900 mb-4">
//                     Session Information
//                   </h2>
//                   <div className="space-y-4">
//                     <div className="flex items-start">
//                       <svg
//                         className="h-5 w-5 text-gray-500 mt-0.5"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                         />
//                       </svg>
//                       <div className="ml-3">
//                         <h4 className="text-sm font-medium text-gray-900">
//                           Added On
//                         </h4>
//                         <p className="text-gray-600">{new Date(sessionData.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
//                       </div>
//                     </div>
//                     <div className="flex items-start">
//                       <svg
//                         className="h-5 w-5 text-gray-500 mt-0.5"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                         />
//                       </svg>
//                       <div className="ml-3">
//                         <h4 className="text-sm font-medium text-gray-900">
//                           Duration
//                         </h4>
//                         <p className="text-gray-600">{sessionData.duration}</p>
//                       </div>
//                     </div>
//                     <div className="flex items-start">
//                       <svg
//                         className="h-5 w-5 text-gray-500 mt-0.5"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
//                         />
//                       </svg>
//                       <div className="ml-3">
//                         <h4 className="text-sm font-medium text-gray-900">
//                           Language
//                         </h4>
//                         <p className="text-gray-600">English</p>
//                       </div>
//                     </div>
//                     <div className="flex items-start">
//                       <svg
//                         className="h-5 w-5 text-gray-500 mt-0.5"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                         />
//                       </svg>
//                       <div className="ml-3">
//                         <h4 className="text-sm font-medium text-gray-900">
//                           Access
//                         </h4>
//                         <p className="text-gray-600">
//                           Lifetime access for subscribers
//                         </p>
//                       </div>
//                     </div>
//                     <div className="flex items-start">
//                       <svg
//                         className="h-5 w-5 text-gray-500 mt-0.5"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
//                         />
//                       </svg>
//                       <div className="ml-3">
//                         <h4 className="text-sm font-medium text-gray-900">
//                           Price
//                         </h4>
//                         <p className="text-gray-600">{sessionData.price || 'Included in subscription'}</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Share Card */}
//               <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
//                 <div className="p-6">
//                   <h2 className="text-xl font-bold text-gray-900 mb-4">
//                     Share This Session
//                   </h2>
//                   <div className="flex space-x-3">
//                     <button className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-600 hover:bg-blue-700 text-white transition-colors duration-300">
//                       <svg
//                         className="w-5 h-5"
//                         fill="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
//                       </svg>
//                     </button>
//                     <button className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-400 hover:bg-blue-500 text-white transition-colors duration-300">
//                       <svg
//                         className="w-5 h-5"
//                         fill="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
//                       </svg>
//                     </button>
//                     <button className="flex items-center justify-center w-10 h-10 rounded-full bg-green-600 hover:bg-green-700 text-white transition-colors duration-300">
//                       <svg
//                         className="w-5 h-5"
//                         fill="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
//                       </svg>
//                     </button>
//                     <button className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-700 transition-colors duration-300">
//                       <svg
//                         className="w-5 h-5"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* Support Card */}
// {/* Support Card */}
// <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-100">
//                 <h2 className="text-xl font-bold text-gray-900 mb-4">
//                   Need Help?
//                 </h2>
//                 <p className="text-gray-600 mb-4">
//                   Having trouble watching this session or have questions about the content?
//                   Our support team is here to help.
//                 </p>
//                 <Link
//                   to="/contact"
//                   className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
//                 >
//                   <span>Contact Support</span>
//                   <svg
//                     className="w-4 h-4 ml-1"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M17 8l4 4m0 0l-4 4m4-4H3"
//                     />
//                   </svg>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-12 bg-gradient-to-r from-indigo-900 to-blue-800 text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <h2 className="text-3xl font-bold mb-6">
//             Ready to Advance Your NPSC Preparation?
//           </h2>
//           <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
//             Get unlimited access to our entire library of recorded sessions and live classes.
//           </p>
//           <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
//             <Link
//               to="/subscribe"
//               className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
//             >
//               Subscribe Now
//             </Link>
//             <Link
//               to="/online-classes"
//               className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
//             >
//               Browse All Sessions
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default WatchSessionPage;              
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { getRecordedSessionById, getRelatedSessions } from "../services/recordedSessionsService";
import VimeoPlayer from "../components/VimeoPlayer";

const WatchSessionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sessionData, setSessionData] = useState(null);
  const [relatedSessions, setRelatedSessions] = useState([]);
  const [activeTab, setActiveTab] = useState("content");
  const [videoProgress, setVideoProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const fetchSessionData = async () => {
      try {
        setLoading(true);
        
        // Fetch session details
        const session = await getRecordedSessionById(id);
        setSessionData(session?.recordedSession);
        
        // Fetch related sessions
        const related = await getRelatedSessions(id);
        setRelatedSessions(related);
        
        setLoading(false);
      } catch (err) {
        console.error("Error fetching session data:", err);
        setError("Failed to load session. Please try again later.");
        setLoading(false);
      }
    };
    
    fetchSessionData();
  }, [id]);

  // Handle video player events
  const handleVideoReady = () => {
    console.log("Video player is ready");
  };
  
  const handleVideoPlay = () => {
    console.log("Video started playing");
  };
  
  const handleVideoPause = () => {
    console.log("Video paused");
  };
  
  const handleVideoEnd = () => {
    console.log("Video playback completed");
  };
  
  const handleTimeUpdate = (data) => {
    // Update progress (as percentage)
    const percent = (data.seconds / data.duration) * 100;
    setVideoProgress(percent);
  };

  if (loading) {
    return (
      <div className="pt-20 flex justify-center items-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin h-12 w-12 text-indigo-600 mx-auto mb-4 rounded-full border-t-2 border-b-2 border-indigo-600"></div>
          <p className="text-gray-600">Loading session...</p>
        </div>
      </div>
    );
  }

  if (error || !sessionData) {
    return (
      <div className="pt-20 flex justify-center items-center min-h-screen">
        <div className="text-center max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
          <svg
            className="h-16 w-16 text-gray-400 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h1 className="text-xl font-bold text-gray-900 mb-2">
            Session Not Found
          </h1>
          <p className="text-gray-600 mb-6">
            {error || "We couldn't find the session you're looking for. It may have been moved or deleted."}
          </p>
          <Link
            to="/online-classes"
            className="inline-flex items-center justify-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-colors duration-300"
          >
            Return to Classes
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20">
      {/* Video Player Header */}
      <section className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-8">
            <div className="flex items-center mb-3">
              <span
                className={`inline-block rounded-full text-xs font-semibold px-2.5 py-0.5 mr-3 ${
                  sessionData.type === "foundation"
                    ? "bg-green-100 text-green-800"
                    : sessionData.type === "prelims"
                    ? "bg-blue-100 text-blue-800"
                    : "bg-purple-100 text-purple-800"
                }`}
              >
                {sessionData?.type?.charAt(0)?.toUpperCase() + sessionData?.type?.slice(1)}
              </span>
              <span className="bg-indigo-100 text-indigo-800 text-xs font-medium rounded px-2.5 py-0.5">
                {sessionData.subject}
              </span>
            </div>
            <h1 className="text-2xl md:text-3xl font-bold mb-4">{sessionData.title}</h1>
            <div className="flex flex-wrap items-center text-sm text-gray-300 mb-4">
              <div className="flex items-center mr-6 mb-2">
                <svg
                  className="w-4 h-4 mr-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                <span>{sessionData.instructor}</span>
              </div>
              <div className="flex items-center mr-6 mb-2">
                <svg
                  className="w-4 h-4 mr-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>{sessionData.duration}</span>
              </div>
              <div className="flex items-center mr-6 mb-2">
                <svg
                  className="w-4 h-4 mr-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                <span>{new Date(sessionData.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
              </div>
              {sessionData.rating && (
                <div className="flex items-center mb-2">
                  <svg
                    className="w-4 h-4 text-yellow-400 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <span>
                    {sessionData.rating} ({sessionData.ratingCount} reviews)
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Vimeo Video Player */}
      <section className="bg-black">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          {/* Using custom VimeoPlayer component */}
          <VimeoPlayer 
            vimeoId={sessionData.vimeoId}
            title={sessionData.title}
            onReady={handleVideoReady}
            onPlay={handleVideoPlay}
            onPause={handleVideoPause}
            onEnd={handleVideoEnd}
            onTimeUpdate={handleTimeUpdate}
          />
          
          {/* Optional: Progress indicator */}
          <div className="mt-2 mb-4 px-1">
            <div className="h-1 w-full bg-gray-700 rounded-full overflow-hidden">
              <div 
                className="h-1 bg-indigo-600 rounded-full" 
                style={{ width: `${videoProgress}%` }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Tabs */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="border-b border-gray-200 mb-8">
            <div className="flex space-x-8">
              <button
                className={`pb-4 text-base font-medium ${
                  activeTab === "content"
                    ? "border-b-2 border-indigo-600 text-indigo-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab("content")}
              >
                Session Content
              </button>
              <button
                className={`pb-4 text-base font-medium ${
                  activeTab === "materials"
                    ? "border-b-2 border-indigo-600 text-indigo-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab("materials")}
              >
                Materials
              </button>
              <button
                className={`pb-4 text-base font-medium ${
                  activeTab === "instructor"
                    ? "border-b-2 border-indigo-600 text-indigo-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab("instructor")}
              >
                Instructor
              </button>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row">
            {/* Main Content Area */}
            <div className="lg:w-2/3 lg:pr-12">
              {/* Session Content Tab */}
              {activeTab === "content" && (
                <div>
                  <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      Session Overview
                    </h2>
                    <p className="text-gray-600 mb-6">{sessionData.description}</p>
                    
                    {sessionData.highlights && sessionData.highlights.length > 0 && (
                      <>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">
                          What You'll Learn
                        </h3>
                        <div className="grid md:grid-cols-2 gap-4 mb-6">
                          {sessionData.highlights.map((highlight, index) => (
                            <div key={index} className="flex items-start">
                              <svg
                                className="h-5 w-5 text-green-500 mt-0.5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M5 13l4 4L19 7"
                                />
                              </svg>
                              <span className="ml-2 text-gray-600">{highlight}</span>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>

                  {sessionData.syllabus && sessionData.syllabus.length > 0 && (
                    <div className="mb-8">
                      <h2 className="text-2xl font-bold text-gray-900 mb-4">
                        Session Syllabus
                      </h2>
                      <div className="border rounded-lg overflow-hidden divide-y divide-gray-200">
                        {sessionData.syllabus.map((section, index) => (
                          <div key={index} className="p-6 bg-white">
                            <div className="flex justify-between items-start mb-2">
                              <h3 className="text-lg font-medium text-gray-900">
                                {section.title}
                              </h3>
                              <span className="bg-gray-100 text-gray-700 text-sm px-2 py-1 rounded">
                                {section.duration}
                              </span>
                            </div>
                            <ul className="pl-5 list-disc text-gray-600">
                              {section.topics.map((topic, topicIndex) => (
                                <li key={topicIndex} className="mb-1">
                                  {topic}
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {sessionData.prerequisites && sessionData.prerequisites.length > 0 && (
                    <div className="mb-8">
                      <h2 className="text-2xl font-bold text-gray-900 mb-4">
                        Prerequisites
                      </h2>
                      <ul className="space-y-2">
                        {sessionData.prerequisites.map((prerequisite, index) => (
                          <li key={index} className="flex items-start">
                            <svg
                              className="h-5 w-5 text-indigo-500 mt-0.5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                            <span className="ml-2 text-gray-600">{prerequisite}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {/* Materials Tab */}
              {activeTab === "materials" && (
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Study Materials
                  </h2>
                  
                  {(!sessionData.materials || sessionData.materials.length === 0) ? (
                    <div className="bg-gray-50 p-6 rounded-lg text-center">
                      <svg
                        className="w-12 h-12 text-gray-400 mx-auto mb-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      <p className="text-gray-600">No materials are available for this session.</p>
                    </div>
                  ) : (
                    <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
                      <ul className="divide-y divide-gray-200">
                        {sessionData.materials.map((material, index) => (
                          <li key={index} className="p-4 hover:bg-gray-50">
                            <div className="flex items-center">
                              <div className="flex-shrink-0 mr-3">
                                <svg
                                  className="h-6 w-6 text-indigo-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                  />
                                </svg>
                              </div>
                              <div className="flex-1">
                                <h3 className="text-base font-medium text-gray-900">
                                  {material}
                                </h3>
                              </div>
                              <div>
                                <button className="inline-flex items-center text-indigo-600 hover:text-indigo-800">
                                  <span>Download</span>
                                  <svg
                                    className="w-4 h-4 ml-1"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {/* Instructor Tab */}
              {activeTab === "instructor" && (
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    About the Instructor
                  </h2>
                  <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
                    <div className="flex items-center mb-6">
                      <div className="mr-4 h-16 w-16 rounded-full overflow-hidden bg-gray-200">
                        {/* Placeholder for instructor image */}
                        <svg
                          className="h-full w-full text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                      </div>
                      <div>
                        <h3 className="font-bold text-lg text-gray-900">
                          {sessionData.instructor}
                        </h3>
                        <p className="text-indigo-600">Expert in {sessionData.subject}</p>
                      </div>
                    </div>
                    <p className="text-gray-600 mb-4">
                      Our instructor is an experienced educator specializing in NPSC exam preparation
                      with extensive knowledge in {sessionData.subject}.
                    </p>
                    <Link
                      to={`/instructors/${sessionData.instructor.toLowerCase().replace(/\s+/g, "-")}`}
                      className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
                    >
                      <span>View Full Profile</span>
                      <svg
                        className="w-4 h-4 ml-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 8l4 4m0 0l-4 4m4-4H3"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              )}

              {/* Related Sessions */}
              {relatedSessions.length > 0 && (
                <div className="mt-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    Related Sessions You May Like
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {relatedSessions.map((relSession) => (
                      <div
                        key={relSession._id}
                        className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300"
                      >
                        <div className="relative h-40">
                          <img
                            src={relSession.image}
                            alt={relSession.title}
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-12 h-12 bg-white/80 rounded-full flex items-center justify-center">
                              <svg
                                className="w-6 h-6 text-indigo-600"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
                              </svg>
                            </div>
                          </div>
                          <div className="absolute top-0 right-0 m-2">
                            <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2 py-0.5 rounded">
                              {relSession.subject}
                            </span>
                          </div>
                          <div className="absolute bottom-0 left-0 m-2">
                            <span className="bg-black/60 text-white text-xs font-medium px-2 py-0.5 rounded">
                              {relSession.duration}
                            </span>
                          </div>
                        </div>
                        <div className="p-4">
                          <h3 className="text-lg font-bold text-gray-900 mb-1 line-clamp-1">
                            {relSession.title}
                          </h3>
                          <p className="text-sm text-gray-600 mb-2">
                            {relSession.instructor}
                          </p>
                          <Link
                            to={`/watch-session/${relSession._id}`}
                            className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
                          >
                            Watch Now
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Sidebar */}
            <div className="lg:w-1/3 mt-8 lg:mt-0">
              {/* Session Info Card */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
                <div className="p-6">
                  <h2 className="text-xl font-bold text-gray-900 mb-4">
                    Session Information
                  </h2>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <svg
                        className="h-5 w-5 text-gray-500 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <div className="ml-3">
                        <h4 className="text-sm font-medium text-gray-900">
                          Added On
                        </h4>
                        <p className="text-gray-600">{new Date(sessionData.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <svg
                        className="h-5 w-5 text-gray-500 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <div className="ml-3">
                        <h4 className="text-sm font-medium text-gray-900">
                          Duration
                        </h4>
                        <p className="text-gray-600">{sessionData.duration}</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <svg
                        className="h-5 w-5 text-gray-500 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                        />
                      </svg>
                      <div className="ml-3">
                        <h4 className="text-sm font-medium text-gray-900">
                          Language
                        </h4>
                        <p className="text-gray-600">English</p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <svg
                        className="h-5 w-5 text-gray-500 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                        />
                      </svg>
                      <div className="ml-3">
                        <h4 className="text-sm font-medium text-gray-900">
                          Access
                        </h4>
                        <p className="text-gray-600">
                          Lifetime access for subscribers
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                    <svg
                        className="h-5 w-5 text-gray-500 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                        />
                      </svg>
                      <div className="ml-3">
                        <h4 className="text-sm font-medium text-gray-900">
                          Price
                        </h4>
                        <p className="text-gray-600">{sessionData.price || 'Included in subscription'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Share Card */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
                <div className="p-6">
                  <h2 className="text-xl font-bold text-gray-900 mb-4">
                    Share This Session
                  </h2>
                  <div className="flex space-x-3">
                    <button className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-600 hover:bg-blue-700 text-white transition-colors duration-300">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
                      </svg>
                    </button>
                    <button className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-400 hover:bg-blue-500 text-white transition-colors duration-300">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                      </svg>
                    </button>
                    <button className="flex items-center justify-center w-10 h-10 rounded-full bg-green-600 hover:bg-green-700 text-white transition-colors duration-300">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                      </svg>
                    </button>
                    <button className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-700 transition-colors duration-300">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Support Card */}
              <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-100">
                <h2 className="text-xl font-bold text-gray-900 mb-4">
                  Need Help?
                </h2>
                <p className="text-gray-600 mb-4">
                  Having trouble watching this session or have questions about the content?
                  Our support team is here to help.
                </p>
                <Link
                  to="/contact"
                  className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium"
                >
                  <span>Contact Support</span>
                  <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </Link>
              </div>

              {/* Video Playback Controls - New Feature */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm mt-8">
                <div className="p-6">
                  <h2 className="text-xl font-bold text-gray-900 mb-4">
                    Playback Settings
                  </h2>
                  <div className="space-y-4">
                    <div>
                      <label htmlFor="playback-speed" className="block text-sm font-medium text-gray-700 mb-1">
                        Playback Speed
                      </label>
                      <select 
                        id="playback-speed" 
                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                        onChange={(e) => {
                          // This would be implemented to control the Vimeo player speed
                          console.log(`Set playback speed to ${e.target.value}`);
                        }}
                      >
                        <option value="0.5">0.5x</option>
                        <option value="0.75">0.75x</option>
                        <option value="1" selected>1x (Normal)</option>
                        <option value="1.25">1.25x</option>
                        <option value="1.5">1.5x</option>
                        <option value="1.75">1.75x</option>
                        <option value="2">2x</option>
                      </select>
                    </div>
                    
                    <div>
                      <label htmlFor="video-quality" className="block text-sm font-medium text-gray-700 mb-1">
                        Video Quality
                      </label>
                      <select 
                        id="video-quality" 
                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                        onChange={(e) => {
                          // This would be implemented to control the Vimeo player quality
                          console.log(`Set video quality to ${e.target.value}`);
                        }}
                      >
                        <option value="auto" selected>Auto</option>
                        <option value="360p">360p</option>
                        <option value="540p">540p</option>
                        <option value="720p">720p (HD)</option>
                        <option value="1080p">1080p (Full HD)</option>
                      </select>
                    </div>

                    <div className="pt-2">
                      <div className="flex items-center justify-between">
                        <span className="flex-grow flex flex-col">
                          <span className="text-sm font-medium text-gray-900">Captions</span>
                          <span className="text-sm text-gray-500">Enable subtitles if available</span>
                        </span>
                        <button 
                          type="button" 
                          className="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 bg-gray-200"
                          role="switch"
                          aria-checked="false"
                          onClick={(e) => {
                            // This would toggle the aria-checked attribute and toggle captions
                            const isChecked = e.currentTarget.getAttribute('aria-checked') === 'true';
                            e.currentTarget.setAttribute('aria-checked', !isChecked);
                            e.currentTarget.classList.toggle('bg-gray-200');
                            e.currentTarget.classList.toggle('bg-indigo-600');
                            console.log(`Captions toggled to ${!isChecked}`);
                          }}
                        >
                          <span aria-hidden="true" className="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-12 bg-gradient-to-r from-indigo-900 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Ready to Advance Your NPSC Preparation?
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
            Get unlimited access to our entire library of recorded sessions and live classes.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link
              to="/subscribe"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
            >
              Subscribe Now
            </Link>
            <Link
              to="/online-classes"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
            >
              Browse All Sessions
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WatchSessionPage;